export enum HotLiveStatusEnum {
    Unspecified = 0,
    Hot = 1,
    Live = 2
}

export enum HotLiveRatingEnum {
    A = 10,
    B = 9,
    C = 8,
    D = 7
}

export enum HotLiveRemoveReasonEnum {
    AcceptedOfferWithUs = 0,
    AcceptedOfferAnotherCompany = 1,
    NotWillingToTravel = 2
}

export enum HotLiveRemoveAgencyFacilityEnum {
    AgencyFacility = 0,
    Unknown = 1,
    Other = 2
}

export enum HotLiveRemoveNurseType {
    New = 0,
    Existing = 1
}
